module.exports = __webpack_public_path__ + "static/media/favicon-32x32.05a48f0b.svg";